import { SynchronizationService } from '../../services/synchronization.service';
import { Injectable } from '@angular/core';
import { DynamicElementService } from '../../services/dynamicElement.service';
import { SyncEventType } from '../../models/enums/syncEventType';
import { ActionViewSynchroHelper } from '../actionview-synchro-helper';
import { ReleasePlanningViewComponent } from './release-planning-view.component';
import { EventSprintCreated } from '../../models/syncEvents/persistenceEvents/eventSprintCreated';
import { SprintService } from '../../services/sprint.service';
import { SettingsService } from '../../services/settings.service';
import { EventSprintDeleted } from '../../models/syncEvents/persistenceEvents/eventSprintDeleted';

/**
 * This class is encapsulating the handling of synchronsation-events for the taskboard-component
 */
@Injectable()
export class ReleaseplanningSynchroHelper {
  constructor(
    private syncService: SynchronizationService,
    private actionViewSync: ActionViewSynchroHelper,
    private dynamicElementService: DynamicElementService,
    private settingsService: SettingsService,
    private sprintService: SprintService
  ) { }

  public initSyncEventListeners(boardComponent: ReleasePlanningViewComponent) {
    // Init events shared by all boards
    this.actionViewSync.initSyncEventListeners(boardComponent);
    // Init events specific to this board
    this.initNewSprintCreatedSubscription(boardComponent);
    this.initSprintDeletedSubscription(boardComponent);
  }

  private initNewSprintCreatedSubscription(boardComponent: ReleasePlanningViewComponent) {
    boardComponent.subscriptions.push(this.syncService.subscribeEvent<any>(SyncEventType.SPRINT_CREATED).subscribe(payload => {
      const event = EventSprintCreated.fromPayload(payload);
      this.sprintService.getSprintDetails(this.settingsService.getProjectName(), event.sprintId).subscribe(newSprint => {
        boardComponent.onSprintCreated(newSprint);
      });
    }));
  }

  private initSprintDeletedSubscription(boardComponent: ReleasePlanningViewComponent) {
    boardComponent.subscriptions.push(this.syncService.subscribeEvent<any>(SyncEventType.SPRINT_DELETED).subscribe(payload => {
      const event = EventSprintDeleted.fromPayload(payload);
      boardComponent.onSprintRemoved(event.sprintId);
    }));
  }


}
